// ----------------------------------------------------------------------
// Organization Affiliations Translations - English
// ----------------------------------------------------------------------

export const affiliationsEn = {
  affiliations: {
    sub_organizations: 'Sub-Organizations',
    supra_org: 'Supra Organization',
    enable_supra_org: 'Enable Supra Organization',
    enable_supra_org_description:
      'Activate this to make your organization an umbrella organization that can have affiliated sub-organizations.',
    disable_supra_org_warning:
      'Disabling this will remove all existing affiliations. This action cannot be undone.',
    affiliated_organizations: 'Affiliated Organizations',
    no_affiliations: 'No affiliated organizations yet.',
    no_affiliations_description:
      'Add organizations that are part of your umbrella structure.',
    add_organization: 'Add Organization',
    search_organizations: 'Search for an organization to affiliate...',
    affiliation_type: 'Affiliation Type',
    type_member: 'Member',
    type_chapter: 'Chapter',
    type_partner: 'Partner',
    status: 'Status',
    status_active: 'Active',
    status_pending: 'Pending',
    status_suspended: 'Suspended',
    joined_at: 'Joined',
    notes: 'Notes',
    notes_placeholder: 'Optional notes about this affiliation...',
    actions: 'Actions',
    remove_affiliation: 'Remove Affiliation',
    remove_affiliation_confirm:
      'Are you sure you want to remove this affiliation? The organization will remain independent and keep all its events.',
    edit_affiliation: 'Edit Affiliation',
    share_public_events: 'Share Public Events',
    share_public_events_description: 'Show this organization\'s public events on the parent organization\'s page',
    share_statistics: 'Share Statistics',
    share_statistics_description: 'Share aggregate statistics with the parent organization',
    use_branding: 'Use Parent Branding',
    use_branding_description: 'Display the parent organization\'s branding on events',
    parent_organization: 'Parent Organization',
    member_of: 'Member of',
    sharing_preferences: 'Sharing Preferences',
    affiliation_created: 'Organization affiliated successfully',
    affiliation_updated: 'Affiliation updated successfully',
    affiliation_removed: 'Affiliation removed successfully',
    supra_enabled: 'Supra organization enabled',
    supra_disabled: 'Supra organization disabled and all affiliations removed',
    already_affiliated: 'This organization is already affiliated with another supra organization',
    cannot_affiliate_self: 'Cannot affiliate an organization with itself',
    only_evenementiel: 'Only event organizations can be affiliated',
    no_results: 'No organizations found',
    select_org: 'Select an organization',
    confirm_disable: 'Confirm Disable',
    cancel: 'Cancel',
    save: 'Save',
    confirm: 'Confirm',
    add: 'Add',
  },
};
